import merge from 'lodash/merge'
import { toDate } from '@ztechapps/common.utils'
import { DateTimeZoneWidget } from './Widgets/DateTimeZone'
import { dateTimeZoneOptions } from './dateTimeZoneOptions'
import { BasicConfig } from 'react-awesome-query-builder'

// const BasicConfig = BrowserOnlyImport(() => require('react-awesome-query-builder').BasicConfig)

const defaultConfig = {
  ...BasicConfig,
}

export const useConfig = ({ config, timeZone }) => {
  const newConfig = merge({}, defaultConfig, config, {
    types: {
      dateTimeZone: {
        ...defaultConfig?.types?.datetime,
        widgets: {
          dateTimeZone: {
            ...defaultConfig?.types?.datetime?.widgets?.datetime,
            widgetProps: {
              options: dateTimeZoneOptions,
            },
          },
        },
      },
    },
    widgets: {
      dateTimeZone: {
        type: 'dateTimeZone',
        valueSrc: 'value',
        mongoFormatValue: (val) => {
          const isDynamic = val?.indexOf?.('<<') !== -1
          if (isDynamic) return val
          else {
            const dateVal = toDate(val, timeZone)
            const result = dateVal.isValid() ? dateVal?.toDate() : val
            return result
          }
        },
        factory: DateTimeZoneWidget,
      },
    },
  })

  return { newConfig }
}
